export default __webpack_public_path__ + "static/media/minusIcon.ef6819cf.svg";